import { Card as CardComponent, CardProps } from '@leroy-merlin-br/backyard-react'

interface CardComponentProps extends CardProps {
  target: string;
}

const Card = (props: CardComponentProps) => <CardComponent {...props} />

export default Card
